import { render } from "./attest-consultant-valid.vue?vue&type=template&id=75bacaf6"
import script from "./attest-consultant-valid.vue?vue&type=script&lang=js"
export * from "./attest-consultant-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__